<template>
	<div class="chat-image-message" :class="bgClass">
		<el-image fit="cover" :src="src" :preview-src-list="[src]">
			<div slot="error" class="image-slot">图片加载失败...</div>
			<div slot="placeholder" class="image-slot">图片加载中...</div>
		</el-image>
	</div>
</template>
<script>
	export default {
		props: {
			src: {
				type: String,
				default: '',
			},
			bgClass: {
			  type: String
			},
		},


	}
</script>
<style lang="scss">
	.chat-image-message {
		display: flex;
		align-items: center;
		&.left,&.right {
			padding: 6px 10px;
			border-radius: 4px;
		}
		&.left {
			background-color: #F6F7F9;
		}
		&.right {
			background-color: #EDF5FF;
		}

		.el-image {
			max-width: 200px;

			.image-slot {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 200px;
				height: 100px;
				font-size: 13px;
				color: #908686;
				background: #efeaea;
			}
		}
	}
</style>
